import { render, staticRenderFns } from "./TextContent.vue?vue&type=template&id=b3cee6c6"
import script from "./TextContent.ts?vue&type=script&lang=ts&external"
export * from "./TextContent.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports